'use strict';

angular.module('mobile-apps')
    .directive('appBackups', ['Authentication', 'AppBackups', 'EntryMain', 'Utilities', 'SweetAlert', '$filter', '$window', function (Authentication, AppBackups,  EntryMain, Utilities, SweetAlert, $filter, $window) {
        return {
            scope:
            {
                mobileApp: '=',
                backupType: '@',
                backupsIncluded: '='
            },
            templateUrl: 'modules/mobile-apps/views/app-backups.client.directive.html',
            link: function (scope, elem, attrs) {

                scope.data = {
                    loading: true,
                    backups: [],
                    backupsDemo: [],
                    backupsDisplay: []
                };

                /**
                 * Initializes the directive by loading demo data
                 */
                function init() {
                    scope.createDemoData();
                }


                /**
                 * Load the current backups
                 */
                function loadBackups() {

                    if (!scope.backupsIncluded || !scope.mobileApp) {
                        // No backups included or mobileApp not initialized then there is nothing to load
                        if (scope.mobileApp) {
                            // If mobileApp exists then we can stop displaying the loading and dispaly the demo
                            // data instead
                            scope.data.loading = false;
                        }
                        return;
                    }

                    scope.data.backups.length = 0;
                    scope.data.loading = true;

                    AppBackups.get({ mobileAppId: scope.mobileApp._id, type: scope.backupType }).$promise
                        .then(
                            function (data) {
                                data.forEach(function (backup) {
                                    scope.data.backups.push(backup);
                                });
                                scope.data.loading = false;
                            }
                        )
                        .catch(
                            function(err) {
                                scope.data.loading = false;
                                Utilities.showMessageErrorResponse(err);
                                console.log(err);
                            }
                        );
                }


                /**
                 * Upgrade the current subscription
                 */
                scope.upgradeSubscription = function() {

                    Utilities.upgradeSubscriptionTeam('backupsManual', scope.mobileApp.user, Authentication.user, scope.mobileApp.team._id, function (err, result) {
                        if (err && err !== 'escape key press') {
                            Utilities.showMessage(
                                'Error!',
                                'There was a problem updating your subscription. Please contact the support! Thanks!',
                                'error'
                            );
                            return;
                        }

                        if (result === true) {
                            // Refresh the page that everything loads new
                            $window.location.reload();
                        }
                    });
                }


                /**
                 * Creates demo data
                 */
                scope.createDemoData = function() {
                    var backupDate;
                    // Create demo-backups for the last 5 days
                    for (var i=5; i > 0; i--) {
                        // Create random a slightly random time (3 min) for every day
                        backupDate = new Date(new Date().getTime() - (24 * 60 * 60 * 1000 * i) - (Math.random() * 3 *  60 * 1000)).toISOString()
                        scope.data.backupsDemo.push({ date: backupDate });
                    }
                };


                /**
                 * Displays the name of the backup in the correct format
                 */
                scope.displayBackupName = function(backup) {
                    var date = $filter('date')(backup.date, 'yyyy-MM-dd');
                    var time = $filter('date')(backup.date, 'HH:mm:ss');

                    return 'Backup from ' + date + ' on ' + time;
                };


                /**
                 * Returns the nicly formated date of the given backup
                 */
                scope.returnBackupDate = function (backup) {
                    return $filter('date')(backup.date, 'yyyy-MM-dd HH:mm:ss');
                };


                /**
                 * Creates a new backup
                 */
                scope.deleteBackup = function (backup) {

                    if (scope.backupType !== 'manual') {
                        // Only manual backups can be deleted
                        return;
                    }

                    SweetAlert.swal(
                        {
                            title: 'Are you sure?',
                            text: 'This will delete the following backup:\n' + scope.returnBackupDate(backup),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes, delete!',
                            cancelButtonText: 'No, cancel!',
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                scope.data.loading = true;
                                AppBackups.delete({ mobileAppId: scope.mobileApp._id, backupDate: backup.date, type: scope.backupType }).$promise
                                    .then(
                                        function (data) {
                                            loadBackups();
                                            scope.data.loading = false;
                                        }
                                    )
                                    .catch(
                                        function (err) {
                                            Utilities.showMessageErrorResponse(err);
                                            scope.data.loading = false;
                                        }
                                    );
                            }
                        }
                    );
                };


                /**
                 * Imports an existing backup
                 */
                scope.importBackup = function(backup) {

                    SweetAlert.swal(
                        {
                            title: 'Are you sure?',
                            text: 'This will import the following backup and overwrite existing data:\n' + scope.returnBackupDate(backup),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes, import!',
                            cancelButtonText: 'No, cancel!',
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                scope.data.loading = true;
                                AppBackups.import({ mobileAppId: scope.mobileApp._id, backupDate: backup.date, backupType: scope.backupType }).$promise
                                    .then(
                                        function (data) {
                                            loadBackups();
                                            scope.data.loading = false;

                                            if (data.errors.length === 0) {
                                                // There was no problem importing

                                                // Reload app data so that all the new languages can get
                                                // accessed without crashing the app
                                                EntryMain.loadMobileApp(scope.mobileApp._id, true);

                                                Utilities.showMessage(
                                                    'Success!',
                                                    'The following backup got imported:\n' + scope.returnBackupDate(backup),
                                                    'success'
                                                );

                                            } else {
                                                // At least some of the imports had problems
                                                Utilities.showMessage('Problems', 'We encountered the following errors on import:<br /> - ' + data.errors.join('<br /> - '), 'error');
                                            }
                                        }
                                    )
                                    .catch(
                                        function (err) {
                                            // There was a bigger problem
                                            Utilities.showMessageErrorResponse(err);
                                            scope.data.loading = false;
                                        }
                                    );
                            }
                        }
                    );
                };


                /**
                 * Creates a new backup
                 */
                scope.createNewBackUp = function() {
                    scope.data.loading = true;
                    AppBackups.create({ mobileAppId: scope.mobileApp._id }).$promise
                        .then(
                            function (data) {
                                loadBackups();
                                scope.data.loading = false;
                            }
                        )
                        .catch(
                            function (err) {
                                Utilities.showMessageErrorResponse(err);
                                scope.data.loading = false;
                            }
                        );
                };


                // Wait till we have the information how many backups are included
                // and the app itself and then load the backups.
                scope.$watch(
                    function () {
                        return scope.backupsIncluded;
                    },
                    function () {
                        if (scope.backupsIncluded) {
                            scope.data.backupsDisplay = scope.data.backups;
                            loadBackups();
                        } else {
                            scope.data.backupsDisplay = scope.data.backupsDemo;
                        }
                    }
                );
                var mobileAppWatch = scope.$watch(
                    function () {
                        return scope.mobileApp;
                    },
                    function () {
                        if (scope.mobileApp) {
                            mobileAppWatch();
                            loadBackups();
                        }
                    }
                );

                init();

            }
        };
    }]);
